import React, { useEffect, useState } from "react";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { UploadOutlined } from "@ant-design/icons";
import {
  Input,
  Button,
  Form,
  Select,
  Space,
  Modal,
  Upload,
  InputNumber,
  message,
} from "antd";
import { Container, Row } from "react-bootstrap";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "../../../services/axiosConfig";
import Helper from "../../../services/Helper";
import { update } from "../../../store/features/orders/createSlice";
import Notification from "../../../services/Notification";
import CustomerDetails from "./customerDetails";

const OrderInfo = ({ updateTab }) => {
  const { Option } = Select;
  const [form] = Form.useForm();
  const [categoryList, setCategoryList] = useState([]);
  const [variantList, setVariantList] = useState([]);
  const [attributes, SetAttributes] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState([]);
  const [disable, setDisable] = useState(true);
  const [disableBtn, setDisableBtn] = useState(false);
  const [prime, setPrime] = useState(false);
  const [nonPrice, setNonPrice] = useState(false);
  let [fieldsCount, setFieldsCount] = useState(1);
  const [priceSettings, setPriceSettings] = useState(true);
  const dispatch = useDispatch();
  const orderStoreDetails = useSelector((state) => state.order.orders);

  let roleId = Helper.UserRole();

  const maxFileSize = 50 * 1024 * 1024;

  useEffect(() => {
    try {
      (async () => {
        var data = await axios
          .get("/category-all", {
            params: {
              path: window.location.pathname,
            },
          })
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });

        if (data && data.data) setCategoryList(data.data.data);

        data = await axios.post("/variant-attributes").catch((error) => {
          Helper.ErrorHanlder(error);
        });

        if (data && data.data) setVariantList(data.data.data);

        if (roleId != 1) {
          data = await axios.get("/shop-view").catch((error) => {
            Helper.ErrorHanlder(error);
          });

          if (data && data.data) {
            dispatch(update({ priceType: data.data.data.priceType }));
            dispatch(update({ points: data.data.data.points }));
          }
        }

        data = await axios.get("/settings-list").catch((error) => {
          Helper.ErrorHanlder(error);
        });

        if (data && data.data) {
          setPriceSettings(data.data.data.points);
        }

        if (window.location.pathname === "/create-custom-order") {
          setDisable(false);
        }
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
    // eslint-disable-next-line
  }, []);

  const onFinish = (values) => {
    if (roleId == 1 && !orderStoreDetails.userId) {
      Notification.warning("Please select the shop");
      return false;
    }

    if (nonPrice && window.location.pathname !== "/create-custom-order") {
      Notification.warning("Please change the product");
      return false;
    }

    values?.users?.map((obj) => {
      obj.images = obj.images?.fileList
        ? _.map(obj.images.fileList, "name")
        : [];
    });
    dispatch(update({ orderDetails: values.users }));
    if (orderStoreDetails.userId !== "783575c4-367c-4502-ac41-2ed773eb461a") {
      updateTab(orderStoreDetails.type === "courier" ? 2 : 3);
    } else {
      updateTab(2);
    }
  };

  const handleChange = async (value, keyvalue) => {
    let formValues = form.getFieldsValue();
    for (const key in formValues.users[keyvalue]) {
      if (
        key !== "images" &&
        key !== "notes" &&
        key !== "price" &&
        key !== "prices" &&
        key !== "points" &&
        key !== "totalDiscountAmount" &&
        key !== "category" &&
        key !== "quantity" &&
        key !== "customOrderProductName" &&
        key !== "customOrderWholesalePrice"
      ) {
        delete formValues.users[keyvalue][key];
      }
    }
    let data = await axios
      .post("/product-by-category", {
        id: value,
      })
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      const newItem = attributes.filter((item) => item.id !== keyvalue);
      SetAttributes([
        ...newItem,
        ...[
          {
            id: keyvalue,
            value: data.data.data,
          },
        ],
      ]);
      if (
        data.data.data.length == 0 &&
        window.location.pathname !== "/create-custom-order"
      ) {
        updatePrice(keyvalue);
      }
    }
  };

  const handlePrice = (id) => {
    let formValues = form.getFieldsValue();
    const newItem = attributes.find((item) => item.id == id);
    let count = 0;
    for (const key in formValues.users[id]) {
      if (
        key !== "images" &&
        key !== "notes" &&
        key !== "price" &&
        key !== "prices" &&
        key !== "points" &&
        key !== "totalDiscountAmount" &&
        key !== "category" &&
        key !== "quantity"
      ) {
        count = count + 1;
      }
    }
    if (
      newItem.value.length === count &&
      window.location.pathname !== "/create-custom-order"
    ) {
      updatePrice(id);
    }
  };

  const updatePrice = async (id) => {
    let formValues = form.getFieldsValue();

    let objDatas = {};
    Object.keys(formValues.users[id]).map(function (key) {
      if (key != "images") {
        objDatas[key] = formValues.users[id][key];
      }
    });

    let data = await axios
      .post("/price-by-category", {
        value: objDatas,
      })
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      let price = data.data.data?.BillingProductDetails[0]?.price;
      if (orderStoreDetails.priceType != "Medium") {
        let discountPrice =
          orderStoreDetails.priceType == "Low"
            ? data.data.data?.Category?.lowDiscount
            : data.data.data?.Category?.discount;
        let discountAmount =
          Number(data.data.data?.BillingProductDetails[0]?.price) *
          Number(Number(discountPrice) / 100);
        if (orderStoreDetails.priceType == "Low") {
          price =
            Number(data.data.data?.BillingProductDetails[0]?.price) -
            Number(discountAmount);
        } else {
          price =
            Number(data.data.data?.BillingProductDetails[0]?.price) +
            Number(discountAmount);
        }
      }
      document.getElementById(
        `dynamic_form_nest_item_users_${id}_prices`,
      ).value = price || 0;

      if (!price || price == 0) {
        setNonPrice(true);
        Notification.warning("Product not available");
      } else {
        setNonPrice(false);
      }

      formValues.users[id] = {
        ...formValues.users[id],
        ...{ price: price || 0 },
      };
      formValues.users[id] = {
        ...formValues.users[id],
        ...{ prices: price || 0 },
      };

      formValues.users[id] = {
        ...formValues.users[id],
        ...{ totalDiscountAmount: 0 },
      };

      formValues.users[id] = {
        ...formValues.users[id],
        ...{
          points:
            priceSettings === true
              ? data.data.data?.BillingProductDetails[0]?.points || 0
              : 0,
        },
      };

      form.setFieldsValue(formValues);

      dispatch(
        update({ courier: data.data.data?.BillingProductDetails[0]?.courier }),
      );

      dispatch(update({ courierType: data.data.data?.courierType }));
    }
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const imageUpload = async ({ file, onSuccess }) => {
    setDisableBtn(true);
    var formData = new FormData();
    formData.append("image", file);
    let data = await axios
      .post("image-upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      setDisableBtn(false);
      onSuccess("ok");
    }
  };

  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    );
  };

  const handleBeforeUpload = (file) => {
    const isFileSizeValid = file.size <= maxFileSize;

    if (!isFileSizeValid) {
      message.error(
        `File size must be less than ${maxFileSize / (1024 * 1024)}MB!`,
      );
    }
    const newName = generateFileName(file.name);
    const newFile = new File([file], newName, { type: file.type });

    if (isFileSizeValid) {
      return newFile;
    } else {
      return Upload.LIST_IGNORE;
    }
  };

  const generateFileName = (originalName) => {
    const uuid = uuidv4();
    const extension = originalName.split(".").pop();
    return `${uuid}.${extension}`;
  };

  const handleUploadImages = ({ file, fileList }) => {
    if (file.status !== "uploading") {
      setFileList(fileList);
    }
  };

  const initialValues = {
    users: [
      { quantity: 1 }, // undefined will render the placeholder
    ],
  };

  return (
    <Container>
      <Row>
        <div className="create-order-info-pg">
          {roleId == 1 && <CustomerDetails />}
          <Form
            name="dynamic_form_nest_item"
            form={form}
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
            initialValues={initialValues}
          >
            {(roleId != 1 || orderStoreDetails.userId) && (
              <>
                <Form.List name="users">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <>
                          <Space
                            key={key}
                            style={{
                              display: "flex",
                              marginBottom: 8,
                            }}
                            align="baseline"
                          >
                            {window.location.pathname ==
                            "/create-custom-order" ? (
                              <Form.Item
                                {...restField}
                                name={[name, "customOrderProductName"]}
                                label="Product Name"
                              >
                                <Input />
                              </Form.Item>
                            ) : null}
                            <Form.Item
                              {...restField}
                              name={[name, "category"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Category is required",
                                },
                              ]}
                              label="Category"
                            >
                              <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(input, option) => {
                                  handleChange(input, key);
                                }}
                              >
                                {categoryList.map((i) => (
                                  <Option key={i.id} value={i.id} variant={i}>
                                    {i.name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                            {attributes.map((obj) => {
                              if (obj.id == key) {
                                let fields = obj.value;
                                return fields.map((val) => (
                                  <Form.Item
                                    {...restField}
                                    name={[name, val.name.toLowerCase()]}
                                    label={val.name}
                                    rules={[
                                      {
                                        required: true,
                                        message: `${val.name} is required`,
                                      },
                                    ]}
                                  >
                                    <Select
                                      showSearch
                                      optionFilterProp="children"
                                      filterOption={(input, option) =>
                                        option.children
                                          .toLowerCase()
                                          .indexOf(input.toLowerCase()) >= 0
                                      }
                                      onChange={(e) => {
                                        handlePrice(key);
                                      }}
                                    >
                                      {val.Attributes.map((i) => (
                                        <Option
                                          key={i.id}
                                          value={i.id}
                                          variant={i}
                                        >
                                          {i.name}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                ));
                              }
                            })}
                            <Form.Item
                              {...restField}
                              name={[
                                name,
                                window.location.pathname !==
                                "/create-custom-order"
                                  ? "prices"
                                  : "price",
                              ]}
                              label="Price"
                            >
                              <Input
                                disabled={disable}
                                style={{ color: "red" }}
                              />
                            </Form.Item>
                            {window.location.pathname ==
                            "/create-custom-order" ? (
                              <Form.Item
                                {...restField}
                                name={[name, "customOrderWholesalePrice"]}
                                label="Retail Price"
                              >
                                <Input />
                              </Form.Item>
                            ) : null}
                          </Space>
                          <div className="order-img order-notes-col">
                            <Form.Item
                              {...restField}
                              name={[name, "quantity"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Quantity is required",
                                },
                              ]}
                              label={"Quantity"}
                            >
                              <InputNumber
                                style={{
                                  width: "100%",
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, "notes"]}
                              label={"Notes"}
                            >
                              <ReactQuill
                                theme="snow"
                                style={{
                                  background: "white",
                                  height: "150px",
                                  width: "450px",
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, "images"]}
                              label={"Files"}
                            >
                              <Upload
                                customRequest={imageUpload}
                                beforeUpload={handleBeforeUpload}
                                listType="picture"
                                multiple
                                defaultFileList={[]}
                                onPreview={handlePreview}
                                onChange={handleUploadImages}
                              >
                                <Button icon={<UploadOutlined />}>
                                  Upload
                                </Button>
                              </Upload>
                            </Form.Item>
                            <MinusCircleOutlined
                              onClick={() => {
                                setFieldsCount(fieldsCount - 1);
                                remove(name);
                              }}
                            />
                          </div>
                        </>
                      ))}
                      {orderStoreDetails.type != "courier" &&
                        (roleId != 1 || orderStoreDetails.userId) &&
                        nonPrice === false && (
                          <Form.Item>
                            <Button
                              type="dashed"
                              onClick={() => {
                                setFieldsCount(fieldsCount + 1);
                                add();
                              }}
                              block
                              icon={<PlusOutlined />}
                            >
                              Add Order
                            </Button>
                          </Form.Item>
                        )}
                    </>
                  )}
                </Form.List>
                <Form.Item style={{ textAlign: "left" }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={disableBtn}
                  >
                    Next
                  </Button>
                  {/* <Button
                style={{
                  margin: "0 8px",
                }}
                onClick={(e) => {
                  updateTab(0);
                }}
              >
                Previous
              </Button> */}
                </Form.Item>
              </>
            )}
          </Form>
        </div>
      </Row>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
    </Container>
  );
};
export default OrderInfo;
